import { defineStore } from 'pinia';
import { accessStoreState, campaignDateTypes } from '@/interfaces/stores/accessStoreState';
import { addDays, formatedDateToFront } from '@/helpers/date';
import { CheckboxAllOption } from '@/interfaces/CheckboxAllOptions';

export const useAccessDataStore = defineStore('useAccessDataStore', {
    state: () =>
        ({
            selectedOperations: [],
            zipCodes: [],
            selectedAgents: [],
            budget: 0,
            minAmount: 20000,
            maxAmount: 30000,
            campaignDurationMin: 2,
            campaignDurationMax: 5,
            cpmFlated: 0,
            operationsMedias: [],
            campaignDates: {
                type: 'delay',
                purchase_delay: 3,
                start_date: null,
                end_date: null,
            },
            bannerPreviewUrl: '',
            avgCapping: 5,
            avgCtr: 0.004,
            purchaseMinDate: '',
            reduction: 1,
            reductionMessage: '',
            diffusionDate: '',
        } as accessStoreState),
    getters: {
        amountToPay(state): number {
            let finalAmountToPay = state.budget;
            if (state.reduction) {
                const reductionAmount = (state.budget * state.reduction) / 100;
                finalAmountToPay -= reductionAmount;
            }
            return finalAmountToPay;
        },
        minBudget(state): number {
            return state.minAmount * state.selectedOperations.length;
        },
        maxBudget(state): number {
            return state.maxAmount * state.selectedOperations.length;
        },
        budgetInEuros(state): number {
            return state.budget / 100;
        },
        impressionsCount(state): number {
            return Math.round((this.budgetInEuros * 1000) / (state.cpmFlated / 100));
        },
        visitsCount(state): number {
            return Math.round(Math.round((this.impressionsCount / state.avgCapping) * state.avgCtr));
        },
        getCampaignStartDate(state): Date {
            const dateType = state.campaignDates.type;

            let startDate = null;
            if (dateType === campaignDateTypes.DELAY) {
                startDate = addDays(Number(state.campaignDates.purchase_delay));
            } else {
                startDate = new Date(state.campaignDates.start_date);
            }

            return startDate;
        },
        getCampaignEndDate(state): Date {
            const dateType = state.campaignDates.type;

            let endDate = null;
            if (dateType === campaignDateTypes.DELAY) {
                endDate = addDays(Number(state.campaignDates.purchase_delay) + state.campaignDurationMax);
            } else {
                endDate = new Date(state.campaignDates.end_date);
            }

            return endDate;
        },
        getMediasToDisplay(state): string[] {
            return state.operationsMedias
                .filter((media) => media.threshold < state.budget)
                .sort((a, b) => a.threshold - b.threshold)
                .map((media) => media.code);
        },
        formatedStartDate(state): string {
            const startDate = state.diffusionDate ? new Date(state.diffusionDate) : this.getCampaignStartDate;
            return formatedDateToFront(startDate);
        },
    },
    actions: {
        setSelectedAgents(agents: CheckboxAllOption<{ amount: number }>[]): void {
            this.selectedAgents = agents;
            this.setSelectedAgentsBudget();
        },
        setSelectedAgentsBudget(): void {
            this.budget = this.selectedAgents.reduce((accumulator, currentValue) => accumulator + currentValue.amount, 0);
        },
    },
});
